/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookmarkedPressReleasesResponseV2AllOf,
    BookmarkedPressReleasesResponseV2AllOfFromJSON,
    BookmarkedPressReleasesResponseV2AllOfFromJSONTyped,
    BookmarkedPressReleasesResponseV2AllOfToJSON,
} from './BookmarkedPressReleasesResponseV2AllOf';
import {
    BookmarkedPressReleasesResponseV2AllOfData,
    BookmarkedPressReleasesResponseV2AllOfDataFromJSON,
    BookmarkedPressReleasesResponseV2AllOfDataFromJSONTyped,
    BookmarkedPressReleasesResponseV2AllOfDataToJSON,
} from './BookmarkedPressReleasesResponseV2AllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 閲覧したプレスリリース一覧を取得したときのレスポンス（新UI用）
 * @export
 * @interface HistoryPressReleasesResponseV2
 */
export interface HistoryPressReleasesResponseV2 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof HistoryPressReleasesResponseV2
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof HistoryPressReleasesResponseV2
     */
    message: string;
    /**
     * 
     * @type {BookmarkedPressReleasesResponseV2AllOfData}
     * @memberof HistoryPressReleasesResponseV2
     */
    data: BookmarkedPressReleasesResponseV2AllOfData;
}

export function HistoryPressReleasesResponseV2FromJSON(json: any): HistoryPressReleasesResponseV2 {
    return HistoryPressReleasesResponseV2FromJSONTyped(json, false);
}

export function HistoryPressReleasesResponseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryPressReleasesResponseV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BookmarkedPressReleasesResponseV2AllOfDataFromJSON(json['data']),
    };
}

export function HistoryPressReleasesResponseV2ToJSON(value?: HistoryPressReleasesResponseV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BookmarkedPressReleasesResponseV2AllOfDataToJSON(value.data),
    };
}

